// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles moved to global src/styles.css */

:host {
  display: block;
}

/* Reset global header element styles that bleed in from styles.css */
:host header {
  height: auto;
  background-image: none;
  background-color: transparent;
  justify-content: space-between;
  font-family: var(--font-main);
}

:host img {
  display: block;
  max-width: 100%;
  height: auto;
  border: 0;
}

:host a {
  text-decoration: none;
  color: inherit;
}

:host .tel-button {
  color: var(--color-purple);
  font-weight: 600;
  text-decoration: none;
  text-transform: uppercase;
  white-space: nowrap;
    font-variant-numeric: lining-nums tabular-nums;
    font-feature-settings: "lnum" 1, "tnum" 1;
}

:host .primary-button {
  color: var(--color-white) !important;
}

/* Site header */
:host .site-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px var(--space-page-x);
  gap: 40px;
}

:host .logo {
  width: 340px;
  height: 80px;
  flex: 0 0 auto;
}

:host .logo a {
  display: block;
}

.logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 40px;
}
 
.primary-button {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  cursor: pointer;
  padding: 16px 34px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-family: var(--font-main);
  font-size: 15px;
  line-height: 1;
  font-weight: 800;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  color: var(--color-white);
  background: var(--color-green-button);
  transition: color var(--transition), background-color var(--transition), border-color var(--transition);
}

.primary-button:link,
.primary-button:visited {
  color: var(--color-white);
  text-decoration: none;
}

.primary-button:hover, 
.primary-button:focus-visible {
  color: var(--color-white);
  border-color: transparent;
  background: var(--color-purple);
}

@media (max-width: 1024px) {
  :root {
    --space-page-x: 32px;
  }

  .site-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .header-actions {
    
    flex-wrap: wrap;
    gap: 18px;
  }
}

@media (max-width: 767px) {
  :root {
    --space-page-x: 20px;
  }

  .site-header,
  .site-footer {
    padding-block: 28px;
  }

  .logo {
    width: 240px;
    height: auto;
  }

  .header-actions {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
}
 `, "",{"version":3,"sources":["webpack://./src/app/LSR/_layout/participant-header/participant-header.component.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,cAAc;AAChB;;AAEA,qEAAqE;AACrE;EACE,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;IACjB,8CAA8C;IAC9C,yCAAyC;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,qCAAqC;EACrC,uGAAuG;AACzG;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;IAEE,eAAe;IACf,SAAS;EACX;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":["/* Styles moved to global src/styles.css */\r\n\r\n:host {\r\n  display: block;\r\n}\r\n\r\n/* Reset global header element styles that bleed in from styles.css */\r\n:host header {\r\n  height: auto;\r\n  background-image: none;\r\n  background-color: transparent;\r\n  justify-content: space-between;\r\n  font-family: var(--font-main);\r\n}\r\n\r\n:host img {\r\n  display: block;\r\n  max-width: 100%;\r\n  height: auto;\r\n  border: 0;\r\n}\r\n\r\n:host a {\r\n  text-decoration: none;\r\n  color: inherit;\r\n}\r\n\r\n:host .tel-button {\r\n  color: var(--color-purple);\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  text-transform: uppercase;\r\n  white-space: nowrap;\r\n    font-variant-numeric: lining-nums tabular-nums;\r\n    font-feature-settings: \"lnum\" 1, \"tnum\" 1;\r\n}\r\n\r\n:host .primary-button {\r\n  color: var(--color-white) !important;\r\n}\r\n\r\n/* Site header */\r\n:host .site-header {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 40px var(--space-page-x);\r\n  gap: 40px;\r\n}\r\n\r\n:host .logo {\r\n  width: 340px;\r\n  height: 80px;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n:host .logo a {\r\n  display: block;\r\n}\r\n\r\n.logo img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n.header-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 40px;\r\n}\r\n \r\n.primary-button {\r\n  width: fit-content;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 48px;\r\n  cursor: pointer;\r\n  padding: 16px 34px;\r\n  border: 1px solid transparent;\r\n  border-radius: 999px;\r\n  font-family: var(--font-main);\r\n  font-size: 15px;\r\n  line-height: 1;\r\n  font-weight: 800;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n  text-decoration: none;\r\n  color: var(--color-white);\r\n  background: var(--color-green-button);\r\n  transition: color var(--transition), background-color var(--transition), border-color var(--transition);\r\n}\r\n\r\n.primary-button:link,\r\n.primary-button:visited {\r\n  color: var(--color-white);\r\n  text-decoration: none;\r\n}\r\n\r\n.primary-button:hover, \r\n.primary-button:focus-visible {\r\n  color: var(--color-white);\r\n  border-color: transparent;\r\n  background: var(--color-purple);\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  :root {\r\n    --space-page-x: 32px;\r\n  }\r\n\r\n  .site-header {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .header-actions {\r\n    \r\n    flex-wrap: wrap;\r\n    gap: 18px;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  :root {\r\n    --space-page-x: 20px;\r\n  }\r\n\r\n  .site-header,\r\n  .site-footer {\r\n    padding-block: 28px;\r\n  }\r\n\r\n  .logo {\r\n    width: 240px;\r\n    height: auto;\r\n  }\r\n\r\n  .header-actions {\r\n    width: 100%;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n}\r\n "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
